import { render, staticRenderFns } from "./ListOpponnents.vue?vue&type=template&id=235ecc97&scoped=true&lang=pug&"
import script from "./ListOpponnents.vue?vue&type=script&lang=js&"
export * from "./ListOpponnents.vue?vue&type=script&lang=js&"
import style0 from "./ListOpponnents.vue?vue&type=style&index=0&id=235ecc97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ecc97",
  null
  
)

export default component.exports